import { render, staticRenderFns } from "./orManagement.vue?vue&type=template&id=8eb36600&scoped=true"
import script from "./orManagement.vue?vue&type=script&lang=js"
export * from "./orManagement.vue?vue&type=script&lang=js"
import style0 from "./orManagement.vue?vue&type=style&index=0&id=8eb36600&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb36600",
  null
  
)

export default component.exports